



































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import to from 'await-to-js';
import { MiguConfig } from '../utils/constant';
import StepText from './stepText.vue';
import StepVideoStyle from './stepVideoStyle.vue';
import StepSpeaker from './stepSpeaker.vue';
import AgreementCheck from './agreementCheck.vue';

@Component({
  components: {
    StepText,
    StepVideoStyle,
    StepSpeaker,
    AgreementCheck,
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class CreateDrawer extends Vue {
  @Prop({ default: false })
  visible!: boolean;

  @Prop({ default: '' })
  theme!: string;

  // 标题（与 textToVideo 一致逻辑）
  get textTitle() {
    return this.isNewYear ? '故事创作' : '第1步，请输入文案';
  }
  get styleTitle() {
    return this.isNewYear ? '我的故事风格' : '第2步，选择视频风格与参数';
  }
  get speakerTitle() {
    return this.isNewYear ? '讲述故事声音' : '第3步，选择发音人和语速';
  }

  @Prop({ default: '' })
  defaultText!: string;

  @Prop({ default: false })
  isNewYear!: boolean;

  @Prop({ default: '' })
  styleCode!: string;

  @Prop({ default: '' })
  speakerName!: string;

  @Prop({ default: 0 })
  speakerStyleId!: number;

  @Prop({ default: '' })
  speakerStyleName!: string;

  @Prop({ default: '' })
  speechSpeed!: string;

  @Prop({ default: false })
  isSubmiting!: boolean;

  // 权益相关（与 submitBtn.vue 一致）
  needCredit = true; // 是否需要判断权益
  leftFreeCount = 0; // 剩余免费次数
  rightsCount = 0; // 权益次数
  needJumpPay = false; // 未通过鉴权，跳转付费页面

  // ============ 协议勾选（提交前必须勾选） ============
  isAgreed = false; // 是否已勾选协议
  isAgreeChecking = false; // 未勾选被点提交时的校验高亮状态

  @Prop({ default: false })
  agreed!: boolean; // 父页面持有的勾选状态（协议弹窗点「我已阅读并同意」后置 true，抽屉销毁重建后恢复）

  get pathSuffix() { return this.$publicPath + 'images/migu/' + (this.isNewYear ? 'newYear/' : ''); }
  get freeIcon() { return this.pathSuffix + 'free_icon.png'; }
  get consumeIcon() { return this.pathSuffix + 'consume_icon.png'; }
  get infoIcon() { return this.pathSuffix + 'info_icon.png'; }
  get commonPub() { return this.$store.getters['miguPage/getCommonPub']; }

  get isCreditExhausted() {
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    return commonPub && !this.leftFreeCount && !this.rightsCount;
  }

  // 收集三个步骤的提交参数
  get textParams() {
    if (!this.$refs.stepTextRef) return {};
    return (this.$refs.stepTextRef as any).submitParams || {};
  }

  get videoStyleParams() {
    if (!this.$refs.stepVideoStyleRef) return {};
    return (this.$refs.stepVideoStyleRef as any).submitParams || {};
  }

  get speakerParams() {
    if (!this.$refs.stepSpeakerRef) return {};
    return (this.$refs.stepSpeakerRef as any).submitParams || {};
  }

  get submitParams() {
    const { text, wordLimit } = this.textParams;
    const { speaker, speakerStyle, speechSpeed } = this.speakerParams;
    const { styleCode, scaleCode, effectCode } = this.videoStyleParams;
    return {
      originContent: text,
      wordLimit,
      styleCode,
      scaleCode,
      effectCode,
      speaker,
      speakerStyle,
      speechSpeed,
    };
  }

  // 用于草稿保存/回显的完整参数（含发音人名称、风格id、风格名、语速）
  get saveParams() {
    const { text } = this.textParams;
    const { speakerName, speakerStyle, speakerStyleId, speechSpeed } = this.speakerParams;
    const { styleCode } = this.videoStyleParams;
    return {
      text,
      speakerName,
      speakerStyle,
      speakerStyleId,
      speechSpeed,
      styleCode,
    };
  }

  // 弹窗打开时查询权益；关闭前把当前草稿同步给父页面（v-if 销毁重建后可回显）
  @Watch('visible')
  onVisibleChange(val: boolean, oldVal: boolean) {
    if (val && this.needCredit) {
      this.queryUserRight();
    }
    if (oldVal && !val) {
      this.$emit('save-local-storage');
    }
  }

  async queryUserRight() {
    const [err, res] = await to(this.$http('getRights'));
    if (err || res.code !== 200) {
      const commonPub = this.$store.getters['miguPage/getCommonPub'];
      if (commonPub) {
        localStorage.removeItem('btoken');
      }
      this.$toast('登录后免费体验');
      return;
    }
    const { status, rightsCount, experienceCount } = res.data.data;
    if (!status) {
      this.needJumpPay = true;
    }
    this.leftFreeCount = experienceCount;
    this.rightsCount = rightsCount;
  }

  handleSubmit() {
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      const btoken = localStorage.getItem('btoken');
      if (!btoken) {
        this.$emit('check-login');
        return;
      }
      if (this.isCreditExhausted) {
        if (localStorage.getItem('autoRedirect') === 'true') {
          window.location.href = 'https://aivrbt.cctctech.com/v1/index';
        } else {
          this.$emit('show-subscribe');
        }
        return;
      }
    }
    // 协议未勾选：抖动提示，拦截提交
    if (!this.isAgreed) {
      this.isAgreeChecking = true;
      this.$toast('请先阅读并勾选授权协议');
      return;
    }
    this.isAgreeChecking = false;
    this.doSubmit();
  }

  doSubmit() {
    if (!this.needCredit) {
      this.doCreateSubmit();
      return;
    }
    if (this.needJumpPay) {
      this.$emit('jump-pay');
      return;
    }
    this.$emit('query-task', this.leftFreeCount || this.rightsCount);
  }

  doCreateSubmit() {
    if (this.isSubmiting) return;
    this.$emit('submit', this.submitParams);
  }

  showOrderTip() {
    window.location.href = 'https://y.migu.cn/app/mp/migu-aigc/h5/index.html?_debug=1#/pages/use-detail/index';
  }

  // ============ 协议勾选相关 ============

  // 勾选框点蓝色协议名：通知父页面弹协议弹窗（父页面负责关抽屉）
  onAgreementLinkClick() {
    this.$emit('show-agreement');
  }

  // 父页面勾选状态变化：同步到内部（协议弹窗同意后父页面置 true）
  @Watch('agreed', { immediate: true })
  onAgreedChange(val: boolean) {
    if (val) this.isAgreed = true;
  }

  // 勾选状态变化：勾上后清除校验高亮
  @Watch('isAgreed')
  onIsAgreedChange(val: boolean) {
    if (val) this.isAgreeChecking = false;
  }
}
